import { Injectable } from '@angular/core';
import { Property, IProperty, IWizardStep, PROPERTY } from '@clooper/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class CorporateAccountWizardService {

  formInstance = new BehaviorSubject<{ formName: string, formGrp: FormGroup }>(({} as any));
  onboardingInstance = new BehaviorSubject<any>((null as any));

  steps: IWizardStep[] = [
    {
      name: 'Start',
      description: 'Basic information about your property',
      url: '/corporate-account/onboarding',
      viewType: 'all',
      draft_stage: 1
    },
    {
      name: 'Invite Employees',
      description: 'Let’s start building your business profile',
      url: '/corporate-account/onboarding/invite-employee',
      viewType: 'all',
      draft_stage: 2
    },
    {
      name: 'Customize Preference',
      description: 'Let’s setup your company travel preferences',
      url: '/corporate-account/onboarding/customize-preference',
      viewType: 'all',
      draft_stage: 3
    },
    {
      name: 'Finish',
      description: 'Confirm the information you’ve provided',
      url: '/corporate-account/onboarding/confirm',
      viewType: PROPERTY.OCCUPANCY_TYPES.SINGLE,
      draft_stage: 4
    },


  ];

  currentStep!: IWizardStep;

  constructor(private router: Router) { }

  resumeOnboarding(account: any) {
    const step = this.steps.find(step => step.draft_stage == account.draft_stage);
    this.router.navigate([step?.url, account.id]).then(() => {
      window.location.reload();
    });
  }

}
